module.exports = __webpack_public_path__ + "static/media/boundaries.05851ef1.svg";